export default "__VITE_ASSET__EWj1bPyE__"